import { installMenu } from './components/menu.js';
import { installVideo } from './components/video.js';

document.addEventListener('DOMContentLoaded', function () {
  installMenu();
  installVideo();
});
